
/* injects from baggage-loader */

'use strict';

/**
 * Constant used in summary module.
 */
const summaryConstant = {
	SUMMARY: {
		LABEL: 'Resumen para '
	},
	CONFIRM_BUTTON: 'Confirmar resumen',
	CANCEL_BUTTON: 'Cancelar',
	CAMPAIGN: {
		LABEL: 'Campaña'
	},
	EMISSION: {
		LABEL: 'Emisión'
	},
	CODE: {
		LABEL: 'Código'
	},
	STATUS: {
		LABEL: 'Estado'
	},
	ID: {
		LABEL: 'Id'
	},
	FILENAME: {
		LABEL: 'Nombre del archivo'
	}
}

export default summaryConstant;



// WEBPACK FOOTER //
// ./src/app/auth/components/summary/summary.constant.js